import * as actions from '../actions'

var defaultState = null

export default function stats(state = defaultState, action) {
    switch (action.type) {

        case actions.GET_STATS:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        case actions.CLEAN_STATS:
            return defaultState

        default:
            return state

    }
}



// WEBPACK FOOTER //
// ./state/reducers/stats.js